module.exports = __webpack_public_path__ + "static/media/logoBIG.f08d1f32.png";